import { inject } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    Router,
    ActivatedRoute,
    Params,
    CanActivateFn
} from '@angular/router';
import { StorageService } from '../service/storage.service';
import { REGISTRATION_COMPLETE, TOKEN, USER_ID } from '../constants/constant';

export const AuthGuard: CanActivateFn = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
) => {
    const localStorage = inject(StorageService)
    const router = inject(Router)
    const activatedRoute = inject(ActivatedRoute)

    if (localStorage.getItem(TOKEN) && localStorage.getItem(USER_ID)) {
        if ((localStorage.getItem(REGISTRATION_COMPLETE) === 'false') && !state.url.includes('signup')) {
            router.navigate(['/signup']);
            return false;
        }
        return true;
    }
    const queryParams: Params = { signIn: 'true' };

    router.navigate([], {
        relativeTo: activatedRoute,
        queryParams: queryParams,
        queryParamsHandling: 'merge',
    });
    return false;
}